import {
    DEPO_ALL_SUCCESS,
    DEPO_CREATE,
    DEPO_FAILED,
    DEPO_HIDE_MODAL,
    DEPO_LOAD, DEPO_LOAD_ALL,
    DEPO_LOADING,
    DEPO_SHOW_MODAL,
    DEPO_SUCCESS, DEPO_UPDATE
} from "../constants/DepoConst";
import {BRANCH_HIDE_MODAL, BRANCH_SHOW_MODAL} from "../constants/BranchConst";


const initState = {
    loading     : false,
    message     : '',
    showMessage : false,
    page        : 1,
    total       : 0,
    data        : [],
    alldata     : []
}

const deporeducer = (state = initState, action) => {
    switch (action.type) {
        case DEPO_LOADING:
            return {
                ...state,
                loading: true,
            }
        case DEPO_SHOW_MODAL:
            return {
                ...state,
                modal: true,
            }
        case DEPO_HIDE_MODAL:
            return {
                ...state,
                modal: false,
            }
        case DEPO_FAILED:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case DEPO_SUCCESS:
            return {
                ...state,
                showMessage: false,
                data:action.data,
                loading: false
            }
        case DEPO_ALL_SUCCESS:
            return {
                ...state,
                showMessage: false,
                alldata:action.data,
                loading: false
            }
        case DEPO_LOAD:
            return {
                ...state,
                loading: true,
            }
        case DEPO_LOAD_ALL:
            return {
                ...state,
                page: action.page,
                loading: true,
            }
        case DEPO_CREATE:
            return {
                ...state,
                loading: true,
            }
            case DEPO_UPDATE:
            return {
                ...state,
                loading: true,
            }

        default:
            return state;
    }
}

export default deporeducer